var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"bg-white tt-text-black rounded-2xl p-4 font-bold text-sm inline-flex items-center justify-between gap-2",class:_vm.shadow},[_c('span',[_vm._v(_vm._s(_vm.slotText))]),_c('button',{on:{"click":function($event){return _vm.closeFunction(_vm.slotText)}}},[_c('XIcon',{staticClass:"w-4 h-4"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }